import { api } from './api';

export const diagnosticService = {
    catalog: (schemeId) => api.get(`/api/admin/diagnostics/catalog${schemeId ? `?scheme_id=${schemeId}` : ''}`),
    listFlows: (schemeId) => api.get(`/api/admin/diagnostics/flows?scheme_id=${schemeId}`),
    getFlow: (flowId) => api.get(`/api/admin/diagnostics/flows/${flowId}`),
    createFlow: (body) => api.post('/api/admin/diagnostics/flows', body),
    deleteFlow: (flowId) => api.delete(`/api/admin/diagnostics/flows/${flowId}`),
    listTemplates: () => api.get('/api/admin/diagnostics/templates'),
    instantiate: (flowId, body) => api.post(`/api/admin/diagnostics/flows/${flowId}/instantiate`, body),
    getVersion: (versionId) => api.get(`/api/admin/diagnostics/versions/${versionId}`),
    putGraph: (versionId, nodes) => api.put(`/api/admin/diagnostics/versions/${versionId}/graph`, { nodes }),
    validate: (versionId) => api.post(`/api/admin/diagnostics/versions/${versionId}/validate`),
    publish: (versionId) => api.post(`/api/admin/diagnostics/versions/${versionId}/publish`),
    analytics: (schemeId) => api.get(`/api/admin/diagnostics/analytics?scheme_id=${schemeId}`),
};

export const triageService = {
    categories: (schemeId) => api.get(`/api/triage/categories?schemeId=${schemeId}`),
    start: (body) => api.post('/api/triage/sessions', body),
    answer: (sessionId, nodeId, value) =>
        api.post(`/api/triage/sessions/${sessionId}/answer`, { nodeId, value }),
    back: (sessionId) => api.post(`/api/triage/sessions/${sessionId}/back`),
    get: (sessionId) => api.get(`/api/triage/sessions/${sessionId}`),
    feedback: (sessionId, body) => api.post(`/api/triage/sessions/${sessionId}/feedback`, body),
};
